import { HeaderRoot } from 'components/Header/Header.styles'
import { styled } from 'stitches.config'

export const Wrapper = styled('div', {
  backgroundColor: '$tertiary-200',
})

export const StepperContainer = styled('div', {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '$1 $3',
  transition: 'margin 0.3s linear',
  position: 'sticky',

  '@bp2': {
    padding: '$2 $3',
  },

  variants: {
    variant: {
      v2: {
        border: 'none',
        borderBottom: '1px solid $tertiary-300',
        backgroundColor: '$tertiary-200',
      },
    },
  },
})

export const MealPlanHeaderRoot = styled('div', {
  position: 'sticky',
  top: 0,
  zIndex: '$max',
})

export const MealPlanHeaderRootV2 = styled('div', {
  backgroundColor: '$tertiary-200',

  '@bp2': {
    paddingTop: 0,
  },

  variants: {
    isScrollingDown: {
      true: {
        [`& ${HeaderRoot}`]: {
          display: 'none',
        },

        [`& ${StepperContainer}`]: {
          borderRadius: 0,
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          margin: 0,
          zIndex: '$1',
        },
      },
    },
  },
})
